import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { FieldMarkerIcon } from "@/components/map/utils/customs";
import TableParameter from "@/components/reports/cultivar-recommendation/components/ParameterBase/TableParameter";
import { toolbarBaseControls } from "@/features/map/utils/configs";
import AgroMapFarm from "@/features/map/presentation/components/AgroMapFarm";
import line from "@assets/images/cultivar_recommendation_report_images/Line185.png";
import frame2182 from "@assets/images/cultivar_recommendation_report_images/Frame2182.png";
import headerImage from "@assets/images/cultivar_recommendation_report_images/headerImage.png";
import footerImage from "@assets/images/cultivar_recommendation_report_images/footerImage.png";
import footerTitle from "@assets/images/cultivar_recommendation_report_images/footerTitle.png";
import agroyaarPlatform from "@assets/images/cultivar_recommendation_report_images/agroyaarPlatform.png";
import cultivarRecommendationIcon from "@assets/images/cultivar_recommendation_report_images/cultivarRecommendationIcon.png";

function ParameterBase({
  cultivarReport,
  cultivarRecommendationsAnalysisResult,
}) {
  const navigate = useNavigate();
  let pageNumber = 0;

  return (
    <>
      <div className="section-container flex flex-col items-center justify-center w-[720px] mx-auto !bg-white">
        {/* Page1 (Introduction) */}
        <div className="page1">
          <div className="flex flex-col justify-between items-center  w-full h-[1048px]">
            <img
              className="header"
              src={headerImage}
              alt="header"
              width="750px"
            />

            <div className="flex flex-col justify-between items-center w-full gap-12 px-8 mt-[-90px]">
              <p
                className="text-[#222] text-[26px] text-center font-bold !font-[B-Nazanin]"
                style={{ textShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)" }}
              >
                کشاورزی{" "}
                <span className="text-president !font-[B-Nazanin]">
                  مطمئن‌
                  <span className="text-[#222] !font-[B-Nazanin]">تر، </span>
                </span>
                <span className="text-president !font-[B-Nazanin]">
                  دقیق‌
                  <span className="text-[#222] !font-[B-Nazanin]">تر و </span>
                </span>
                <span className="text-president !font-[B-Nazanin]">
                  اقتصادی‌
                  <span className="text-[#222] !font-[B-Nazanin]">تر</span>
                </span>
                <p className="text-[#000] font-semibold text-[20px] whitespace-nowrap !font-[B-Nazanin]">
                  هدف ما تصمیم‌گیری برای کشاورز نیست، کمک به تصمیم‌گیری بهتر
                  کشاورز است
                </p>
              </p>

              <div className="flex flex-col items-center mt-[-20px]">
                <img
                  src={cultivarRecommendationIcon}
                  className="w-[240px] h-[240px] !font-[B-Nazanin]"
                  alt="cultivar-icon"
                />
                <div className="flex flex-col text-center">
                  <span
                    className="text-[#5700B4] font-bold text-[3rem] !font-[B-Nazanin]"
                    style={{
                      textShadow: "1px 0px 3px rgba(118, 118, 118, 0.61)",
                    }}
                  >
                    گزارش انتخاب رقم مناسب
                  </span>
                  <span className="text-[#5700B4] font-bold text-[1.8rem] !font-[B-Nazanin]">
                    (بر اساس مقاومت به آفات، بیماری‌ها و تنش‌ها)
                  </span>
                </div>
              </div>

              <img
                src={line}
                alt="line"
                width="750px"
                className="mt-[-90px] mr-0 mb-[-45px] ml-0"
              />
              <div className="flex flex-row justify-start items-center w-full gap-5 mt-[-30px] px-4">
                <div className="flex flex-col justify-between items-start w-[50%] gap-2">
                  <span className="font-bold text-[20px] text-[#222] !font-[B-Nazanin]">
                    اطلاعات کشاورز
                  </span>

                  <div className="flex flex-row-reverse justify-end items-center gap-[19px] w-full">
                    <div className="text-agrotext font-bold text-[18px] flex flex-col justify-center items-start gap-[6px]">
                      <span className="!font-[B-Nazanin]">
                        {cultivarReport?.farmer?.firstName}{" "}
                        {cultivarReport?.farmer?.lastName}
                      </span>

                      <div className="flex flex-row items-start gap-2">
                        <span className="!font-[B-Nazanin]">کد کشاورزی:</span>
                        <span className="!font-sans text-[16px]">
                          {cultivarReport?.farmer?.farmerCode}
                        </span>
                      </div>

                      <div className="flex flex-row items-start gap-2">
                        <span className="!font-[B-Nazanin]">استان و شهر:</span>
                        <span className="!font-[B-Nazanin]">
                          {cultivarReport?.farmer?.province?.name}،{" "}
                          {cultivarReport?.farmer?.city?.name}
                        </span>
                      </div>
                    </div>

                    <img
                      src={
                        process.env.REACT_APP_ARVAN_S3_BASE_URL +
                        cultivarReport?.farmer?.avatar
                      }
                      alt="profile"
                      width="70px"
                      height="70px"
                      className="rounded-full border-[2px] border-solid border-president"
                    />
                  </div>
                </div>
                {cultivarReport?.expert && (
                  <div className="flex flex-col justify-center items-start w-[50%] gap-2">
                    <span className="font-bold text-[20px] text-[#222] !font-[B-Nazanin]">
                      اطلاعات کارشناس
                    </span>

                    <div className="flex flex-row-reverse justify-end items-center gap-[19px] w-full">
                      <div className="text-agrotext font-bold text-[18px] flex flex-col justify-center items-start gap-[6px]">
                        <span className="!font-[B-Nazanin]">
                          {cultivarReport?.farmer?.firstName}{" "}
                          {cultivarReport?.farmer?.lastName}
                        </span>

                        <div className="flex flex-row items-start gap-2">
                          <span className="!font-[B-Nazanin]">کد کارشناس:</span>
                          <span className="!font-sans text-[16px]">
                            {cultivarReport?.farmer?.farmerCode}
                          </span>
                        </div>

                        <div className="flex flex-row items-start gap-2">
                          <span className="!font-[B-Nazanin]">
                            استان و شهر:
                          </span>
                          <span className="!font-[B-Nazanin]">
                            {cultivarReport?.farmer?.province?.name}،{" "}
                            {cultivarReport?.farmer?.city?.name}
                          </span>
                        </div>
                      </div>

                      <img
                        src={
                          process.env.REACT_APP_ARVAN_S3_BASE_URL +
                          cultivarReport?.farmer?.avatar
                        }
                        alt="profile"
                        width="70px"
                        height="70px"
                        className="rounded-full border-[2px] border-solid border-president"
                      />
                    </div>
                  </div>
                )}
              </div>

              <img
                src={line}
                alt="line"
                width="750px"
                className="mt-[-90px] mr-0 mb-[-45px] ml-0"
              />

              <div className="flex flex-row justify-center items-end w-full gap-7 px-4">
                <div className="flex flex-col justify-center items-start w-[50%] gap-2">
                  <span className="font-bold text-[20px] text-[#222] !font-[B-Nazanin]">
                    اطلاعات زمین
                  </span>

                  <div className="flex flex-row-reverse justify-end items-center gap-4 w-full">
                    <div className="w-[70%] text-agrotext font-bold text-[18px] flex flex-col justify-center items-start gap-[6px]">
                      <div className="flex flex-row items-start w-full justify-between gap-2">
                        <span className="!font-[B-Nazanin]">نام قطعه:</span>
                        <span className="!font-[B-Nazanin]">
                          {cultivarReport?.season?.farm?.name}
                        </span>
                      </div>

                      <div className="flex flex-row items-start w-full justify-between gap-2">
                        <span className="!font-[B-Nazanin]"> استان:</span>
                        <span className="!font-[B-Nazanin]">
                          {cultivarReport?.season?.farm?.province?.name}
                        </span>
                      </div>

                      <div className="flex flex-row items-start w-full justify-between gap-2">
                        <span className="!font-[B-Nazanin]">شهر:</span>
                        <span className="!font-[B-Nazanin]">
                          {cultivarReport?.season?.farm?.city?.name}
                        </span>
                      </div>
                    </div>

                    <div className="relative w-[80px] h-[80px] overflow-clip rounded-[999px]">
                      <div className="THISISFORMAPLOCK! bg-transparent z-[99999999] w-full h-full absolute"></div>
                      <AgroMapFarm
                        mapId={cultivarReport?.season?.farm?.id}
                        type="onlyShow"
                        toolbarOptions={toolbarBaseControls}
                        markerIcon={FieldMarkerIcon}
                        currentFarmPolygon={
                          cultivarReport?.season?.farm?.polygon
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="flex flex-col justify-center items-start w-[50%] gap-2">
                  <span className="font-bold text-[20px] text-[#222] !font-[B-Nazanin] items-start">
                    اطلاعات فصل رشد
                  </span>
                  <div className="flex flex-row-reverse justify-end items-center gap-4 w-full">
                    <div className="w-[70%] text-agrotext font-bold text-[18px] flex flex-col justify-center items-start gap-[6px]">
                      <div className="flex flex-row items-start w-full justify-between gap-2">
                        <span className="!font-[B-Nazanin]">نام محصول:</span>
                        <span className="!font-[B-Nazanin]">
                          {cultivarReport?.season?.product?.persianName}
                        </span>
                      </div>

                      <div className="flex flex-row items-start w-full justify-between gap-2 ">
                        <span className="!font-[B-Nazanin]">مساحت زمین</span>
                        <span className="!font-[B-Nazanin]">
                          {cultivarReport?.season?.area} هکتار
                        </span>
                      </div>

                      <div className="flex flex-row items-start w-full justify-between gap-2">
                        <span className="!font-[B-Nazanin]">فصل رشد:</span>
                        <span className="!font-[B-Nazanin]">
                          {parseFloat(
                            cultivarReport?.season?.centerCoordinates[1]?.toFixed(
                              4
                            )
                          )}{" "}
                          ،{" "}
                          {parseFloat(
                            cultivarReport?.season?.centerCoordinates[0]?.toFixed(
                              4
                            )
                          )}
                        </span>
                      </div>
                    </div>

                    <img
                      src={cultivarReport?.season?.product?.imageUrl}
                      alt="product-name"
                      width="80px"
                      height="80px"
                      className="rounded-full"
                    />
                  </div>
                </div>
              </div>

              <img
                src={line}
                alt="line"
                width="750px"
                className="mt-[-50px] mr-0 mb-[-30px] ml-0"
              />
            </div>

            <div className="footer w-full flex flex-col justify-start items-center relative">
              <img
                className="absolute bottom-0 z-[2]"
                src={footerImage}
                width="750px"
                alt="footer"
              />
              <img
                className="absolute bottom-2 left-[30px] z-[3]"
                src={footerTitle}
                alt="footer-title"
              />
              <span className="absolute bottom-1 left-[60px] z-[3] text-[12px] font-bold text-[#fff] tracking-[9px] text-center">
                WWW.AGROYAAR.COM
              </span>
              <span className="absolute bottom-[5px] right-[15px] z-[3] text-[18px] font-semibold text-[#fff]">
                {++pageNumber}
              </span>
            </div>
          </div>
        </div>

        {/* <!-- Page2 --> */}
        <div className="page2">
          <div className="flex flex-col justify-start items-center w-full h-[1048px]">
            <img
              className="header"
              src={frame2182}
              alt="header"
              width="750px"
            />
            <div className="flex flex-col flex-grow justify-start items-center w-full gap-14 px-8 ">
              <div className="flex flex-col  w-full gap-5  px-4">
                <h2 className="text-lg font-bold leading-4 !font-[B-Nazanin]">
                  تعریف ارقام در کشاورزی
                </h2>
                <p className="text-base font-normal leading-8 !font-[B-Nazanin]">
                  ارقام در زراعت و باغبانی دسته‌ای از گیاهان هستند که از یک گونه
                  گیاهی مشتق شده و طی پروسه‌های اصلاح ژنتیکی بسته به صفات مدنظر
                  اصلاح‌گران در جهت رفع نیاز کشاورزان به بخش کشاورزی معرفی
                  شده‌اند.
                </p>
              </div>
              <div className="flex flex-row justify-between">
                <div className="flex flex-col gap-3 w-[60%] px-4">
                  <h2 className="text-lg font-bold !font-[B-Nazanin]">
                    اهمیت انتخاب رقم مناسب
                  </h2>
                  <p className="text-base font-normal !font-[B-Nazanin] w-full item text-justify leading-8">
                    ارقام مختلف یک گیاه حداکثر رشد و عملکرد خود را در مجموعه
                    خاصی از عوامل محیطی دارد. هر چه سازگاری یک رقم با شرایط
                    طبیعی رشد کمتر باشد، به فعالیت­ها و عملیات زراعی بیشتری در
                    جهت افزایش عملکرد آن رقم نیاز خواهد بود. به عنوان مثال اگر
                    رقم انتخابی شما حساس به شوری خاک باشد شما باید در کنار سایر
                    مدیریت­های لازم برای محصول خود، مدیریت دقیق­تر و بیشتری نسبت
                    به شوری خاک داشته باشید تا عملکرد محصول دچار افت شدید نگردد.
                  </p>
                </div>
                <div className="w-[264px] h-[254px] ">
                  <img
                    className="w-full object-cover rounded-3xl"
                    src={cultivarReport?.season?.product?.imageUrl}
                    alt={cultivarReport?.season?.product?.persianName}
                  />
                </div>
              </div>
              <div className="border-president flex flex-col border-2 rounded-lg p-2 gap-2 ">
                <h2 className="font-bold text-lg !font-[B-Nazanin]">
                  ارقام انتخابی{" "}
                  <span className="font-bold text-base text-president !font-[B-Nazanin]">
                    {cultivarReport?.season?.product?.persianName}
                  </span>
                </h2>
                <p className="font-normal text-base !font-[B-Nazanin] leading-5">
                  سامانه انتخاب رقم اگرویار با توجه به شرایط اقلیمی، سطح مقاومت
                  به تنش‌­های محیطی، آفات، بیماری‌­ها و سایر خصوصیات انتخابی
                  شما، از بانک اطلاعات ارقام موجود در سامانه
                  <span className="font-bold text-base text-president !font-[B-Nazanin]">
                    {" "}
                    {cultivarRecommendationsAnalysisResult.length} رقم{" "}
                    {cultivarReport?.season?.product?.persianName}{" "}
                  </span>{" "}
                  را پیشنهاد داده است. شرح کامل خصوصیات این ارقام، به ترتیب
                  اولویت آن‌­ها، در جدول زیر ارائه شده است.
                </p>
              </div>
            </div>

            <div className="footer w-full flex flex-col justify-start items-center relative bottom-0">
              <img
                className="absolute bottom-0 z-[2]"
                src={footerImage}
                width="750px"
                alt="footer"
              />
              <img
                className="absolute bottom-2 left-[30px] z-[3]"
                src={agroyaarPlatform}
                alt="footer"
              />
              <span className="absolute bottom-[5px] left-[30px] z-[3] text-[12px] font-bold text-[#fff] !font-sans">
                کد گزارش: {cultivarReport?.cultivarRecommendationCode}
              </span>
              <span className="absolute bottom-[5px] right-[15px] z-[3] text-[18px] font-semibold text-[#fff]">
                {++pageNumber}
              </span>
            </div>
          </div>
        </div>

        {/* Page3 (generating dynamic pages) */}
        {cultivarRecommendationsAnalysisResult?.length > 0 && (
          <div className="page3">
            <div className="flex flex-col justify-start items-center w-full h-[1048px]">
              <img
                className="header"
                src={frame2182}
                alt="header"
                width="750px"
              />

              <div className="flex flex-col flex-grow  w-full gap-5  px-8">
                <h2 className="text-lg font-bold leading-4 !font-[B-Nazanin]">
                  جدول 1- ارقام گندم پیشنهادی با توجه به خصوصیات انتخابی شما
                </h2>
                <TableParameter
                  cultivarRecommendationsAnalysisResult={
                    cultivarRecommendationsAnalysisResult
                  }
                />
              </div>

              <div className="footer w-full flex flex-col justify-start items-center relative bottom-0">
                <img
                  className="absolute bottom-0 z-[2]"
                  src={footerImage}
                  width="750px"
                  alt="footer"
                />
                <img
                  className="absolute bottom-2 left-[30px] z-[3]"
                  src={agroyaarPlatform}
                  alt="footer"
                />
                <span className="absolute bottom-[5px] left-[30px] z-[3] text-[12px] font-bold text-[#fff] !font-sans">
                  کد گزارش: {cultivarReport?.cultivarRecommendationCode}
                </span>
                <span className="absolute bottom-[5px] right-[15px] z-[3] text-[18px] font-semibold text-[#fff]">
                  {++pageNumber}
                </span>
              </div>
            </div>
          </div>
        )}

        <div className="flex flex-col">
          <Button
            className="button-neo h-fit !text-[#333] hover:brightness-105 fixed top-[20px] right-[100px] max-lg:right-[32px] px-8 text-[18px]  w-[150px]"
            id="download-button"
            onClick={() => window.print()}
          >
            <p>پرینت گزارش</p>
          </Button>
          <Button
            className="button-neo h-fit !text-[#333] hover:brightness-105 fixed top-[65px] right-[100px] max-lg:right-[32px] px-8 text-[18px] w-[150px]"
            id="download-button"
            onClick={() => window.close()}
          >
            <p> بازگشت</p>
          </Button>
        </div>
      </div>
    </>
  );
}

export default ParameterBase;
